import script from "./emailComponentViewColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./emailComponentViewColumn.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__